import { addAlert } from '../../MsgNotify/msgNotifyActions';
import { httpGetNoAuth, httpGet, httpPost, httpPut } from '../../Util/http';
import { routeActions } from 'redux-simple-router';

import auth from '../../Login/authService'

export const SET_ROW_SHOULD_UPDATE = 'SET_ROW_SHOULD_UPDATE';
export function setRowShouldUpdate(rootKey, secondKey, thirdKey){
    return {
        type: SET_ROW_SHOULD_UPDATE,
        rowShouldUpdate: {
            rootKey: rootKey,
            secondKey: secondKey,
            thirdKey: thirdKey
        }
    }
}



export const GET_WORKPLACE_SUGGESTIONS_REQUEST = 'GET_WORKPLACE_SUGGESTIONS_REQUEST';
export function getWorkplaceSuggestionsRequest(){
    return {
        type: GET_WORKPLACE_SUGGESTIONS_REQUEST
    }
}

export const GET_WORKPLACE_SUGGESTIONS_SUCCESS = 'GET_WORKPLACE_SUGGESTIONS_SUCCESS';
export function getWorkplaceSuggestionsSuccess(json){
    var suggestions = [];
    json.forEach(function(suggestion, index) {
        if (index > 4 ) return;
        suggestions.push({id:suggestion.adgangsadresse.id, name: suggestion.tekst})
    });

    return {
        type: GET_WORKPLACE_SUGGESTIONS_SUCCESS,
        suggestions: suggestions
    }
}

export const GET_WORKPLACE_SUGGESTIONS_FAILURE = 'GET_WORKPLACE_SUGGESTIONS_FAILURE';
export function getWorkplaceSuggestionsFailure(){
    return {
        type: GET_WORKPLACE_SUGGESTIONS_FAILURE
    }
}



export function getWorkplaceSuggestions(val) {
    var fetchUrl = "http://dawa.aws.dk/adgangsadresser/autocomplete?q="+val+"&type=adgangsadresse&fuzzy=";

    return dispatch => {
        dispatch(getWorkplaceSuggestionsRequest());
        return httpGetNoAuth(fetchUrl)
         .then(response => {
            return response.json();
        })
        .then((json) => dispatch(getWorkplaceSuggestionsSuccess(json)))
        .catch(() => {
            dispatch(getWorkplaceSuggestionsFailure());
        })
  };
}

export const GET_WORKPLACE_LOCATION_SUCCESS = 'GET_WORKPLACE_LOCATION_SUCCESS';
export function getWorkplaceLocationSuccess(json){
    return {
        type: GET_WORKPLACE_LOCATION_SUCCESS,
        workplaceLong: json.adgangspunkt.koordinater[0],
        workplaceLat: json.adgangspunkt.koordinater[1]
    }
}

export function getWorkplaceLocation(workplaceDawaId) {
    var fetchUrl = "http://dawa.aws.dk/adgangsadresser/" + workplaceDawaId;
    return dispatch => {
        return httpGetNoAuth(fetchUrl)
         .then(response => {
            return response.json();
        })
        .then((json) => dispatch(getWorkplaceLocationSuccess(json)))
        .catch(() => {
        })
  };
}



/* + */

export const GET_SUGGESTIONS_SUCCESS = 'GET_SUGGESTIONS_SUCCESS';
export function getSuggestionsSuccess(suggestions, suggestionsFor){
    return {
        type: GET_SUGGESTIONS_SUCCESS,
        suggestions: suggestions,
        suggestionsFor: suggestionsFor
    }
}



export function getSuggestions(val, suggestionsFor) {
    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "/api/"+suggestionsFor+"/search?query=" + val
    return (dispatch, getState) => {
        return httpGet(fetchUrl)
         .then(response => {
            return response.json();

        })
        .then((json) => {
            var jsonReponse = suggestionsFor==='client' ? json : stripSuggestions(json, getState, suggestionsFor)
            dispatch(getSuggestionsSuccess(jsonReponse, suggestionsFor))
        })
        .catch((e) => {
            console.log(e);
        })
  };
}

function stripSuggestions(suggestions, getState, suggestionsFor){
    var alreadyChosen = getState().form.createProjectWizard[suggestionsFor+"s"];
    var newSuggestions = [];
    suggestions.forEach(function(suggestion) {
        var allowedSugg = true;
        //check if already chosen from suggestions
        alreadyChosen.forEach(function(chosen) {
            if (chosen.value)
                if(chosen.value.id===suggestion.id) allowedSugg = false;
            if (chosen.id)
                if (chosen.id===suggestion.id) allowedSugg = false;

        });
        //if suggestions is for users, remove current user
        if (suggestionsFor==="employee")
            if (auth.getProfile().username.toUpperCase()===suggestion.id) allowedSugg = false;

        if (allowedSugg) newSuggestions.push(suggestion);
    })
    return newSuggestions;

}

export const IS_PROJECTNUMBER_RESERVED_SUCCESS = 'IS_PROJECTNUMBER_RESERVED_SUCCESS';
export function isProjectNumberReservedSuccess(projectNumberReserved){
    return {
        type: IS_PROJECTNUMBER_RESERVED_SUCCESS,
        projectNumberReserved: projectNumberReserved
    }
}



export function isProjectNumberReserved(projectNumber) {
    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "api/project/reserved/" + projectNumber
    return (dispatch, getState) => {
        if(getState().projectFormReducer.data.projectNumber===projectNumber){
            dispatch(isProjectNumberReservedSuccess(false))
            return;
        }
        return httpGet(fetchUrl)
         .then(response => {
            return response.json();
        })
        .then((json) => {

            dispatch(isProjectNumberReservedSuccess(json))
        })
        .catch(() => {

        })
  };
}


export const SUBMIT_FORM_REQUEST = 'SUBMIT_FORM_REQUEST';
export function submitFormRequest(){
    return {
        type: SUBMIT_FORM_REQUEST
    }
}

export const SUBMIT_FORM_SUCCESS = 'SUBMIT_FORM_SUCCESS'
export function submitFormSuccess() {
    return {
        type: SUBMIT_FORM_SUCCESS
    };
}

export const SUBMIT_FORM_FAILURE = 'SUBMIT_FORM_FAILURE'
export function submitFormFailure() {
    return {
        type: SUBMIT_FORM_FAILURE,
        redirectTo: null
    };
}


export function attemptSubmitForm() {
    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "api/project";
    return (dispatch, getState) => {
        dispatch(submitFormRequest());
        var obj = submitFormMapper(getState().form.createProjectWizard, getState().projectFormReducer);

        return httpPost(fetchUrl, obj)
        .then(() => {

            setTimeout(() => {
                dispatch(routeActions.push('/tilbud'))
                dispatch(submitFormSuccess())
                dispatch(addAlert("Sag " + obj.number + " blev oprettet", "success"))
            }, 4000);

        })
        .catch(() => {
            dispatch(submitFormFailure())
            dispatch(addAlert("Der skete en systemfejl under oprettelsen, kontakt venligst support om fejlen"))
        })
  };
}

function submitFormMapper(formData, projectFormReducer){

    var finalObj = {
        name: formData.projectName.value,
        number: formData.projectNumber.value,
        client: formData.client.value,
        //TODO LOCATION LAT LONG

        weeklyRoutine: {
            mon: formData.mon.value,
            tue: formData.tue.value,
            wed: formData.wed.value,
            thu: formData.thu.value,
            fri: formData.fri.value,
            sat: formData.sat.value,
            sun: formData.sun.value
        }
    }

    //add location
    var location = null
    if (formData.address.value){
        location = {address: formData.address.value.name}

        if(projectFormReducer.workplaceLong){
            location.lng = projectFormReducer.workplaceLong
            location.lat = projectFormReducer.workplaceLat
        }
    }
    finalObj.location = location;

    var contacts = [];
    //add contacts
    formData.contacts.forEach((contact)=>{
        //if contact name got value add him as an object to the array
        if(contact.name.value){
            var newContact = {
                name: contact.name.value,
                title: contact.title.value,
                email: contact.email.value,
                telephone: contact.telephone.value
            }
            contacts.push(newContact);
        }
    })

    finalObj.contacts = contacts;

    var employees = [];
    //add employees
    formData.employees.forEach((employee)=>{
        //if contact name got value add him as an object to the array
        if(employee.value){
            var newEmployee = {
                id: employee.value.id
            }
            employees.push(newEmployee);
        }
    })

    finalObj.employees = employees;

    var activities = [];
    //add activities
    formData.rootActivities.forEach((rootActivty, index) =>{
        //if rootactivity has a name: create the object
        if (rootActivty.name.value){
            var newRootActivity = {
                name: rootActivty.name.value,
                activities: [],
                subActivities: [],
                position: index+1
            }
            rootActivty.seconds.forEach((second, index)=>{
                if(second.name.value){
                    var newSecond = {
                        name: second.name.value,
                        position: index+1
                    }

                    var doesSecondHaveValidChilren = false;

                    second.thirds.forEach((third, index)=>{
                        if (third.name.value){
                            doesSecondHaveValidChilren = true;
                            if(!newSecond.activities) newSecond.activities = [];
                            var newThird = {
                                amount: third.amount.value,
                                name: third.name.value,
                                unit: third.unit.value,
                                hoursPerUnit: third.hoursPerUnit.value,
                                sum: third.sum.value,
                                position: index+1
                            }
                            newSecond.activities.push(newThird);
                        }

                    });

                    if (!doesSecondHaveValidChilren){
                        newSecond.unit = second.unit.value;
                        newSecond.amount = second.amount.value;
                        newSecond.hoursPerUnit = second.hoursPerUnit.value;
                        newSecond.sum = second.sum.value;
                        newRootActivity.activities.push(newSecond);
                    }
                    else{
                        newRootActivity.subActivities.push(newSecond);
                    }
                }
            });

            activities.push(newRootActivity);
        }

    });




    finalObj.activities = activities;


    return finalObj
}



export const LOAD_FORM_EDIT_PROJECT_DATA = 'LOAD_FORM_EDIT_PROJECT_DATA'
export function loadFormEditProjectData(json) {
    let users = json.users;
    json.users = [];
    return {
        type: LOAD_FORM_EDIT_PROJECT_DATA,
        data: json,
        users: users
    };
}

export function attemptGetEditData(projectNumber) {
    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "api/project/edit?number=" + projectNumber
    return (dispatch) => {
        return httpGet(fetchUrl)
         .then(response => {
            return response.json();
        })
        .then((json) => {
            dispatch(loadFormEditProjectData(json))
        })
        .catch(() => {
            dispatch(routeActions.push('/tilbud/sag/' + projectNumber))
            dispatch(addAlert("Der skete en fejl, prøv venligst igen"))
        })
  };
}


export function attemptEditForm() {
    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "api/project/update";
    return (dispatch, getState) => {
        dispatch(submitFormRequest());
        var project = editFormMapper(getState().form.createProjectWizard, getState().projectFormReducer);

        return httpPut(fetchUrl, project)
        .then(() => {
            setTimeout(() => {
                dispatch(routeActions.push('/tilbud/sag/' + getState().form.createProjectWizard.projectNumber.value))
                dispatch(submitFormSuccess())
                dispatch(addAlert("Dine ændringer blev gemt", "success"))
            }, 4000);
        })
        .catch(() => {
            dispatch(submitFormFailure())
            dispatch(addAlert("Der skete en systemfejl under redigeringen, kontakt venligst support om fejlen"))
        })
  };
}

function editFormMapper(values, projectFormReducer){
    let formData = values;
    var finalObj = {
        id: projectFormReducer.data.projectId,
        name: formData.projectName.value,
        number: formData.projectNumber.value,
        client: formData.client.value,
        //TODO LOCATION LAT LONG

        weeklyRoutine: {
            mon: formData.mon.value,
            tue: formData.tue.value,
            wed: formData.wed.value,
            thu: formData.thu.value,
            fri: formData.fri.value,
            sat: formData.sat.value,
            sun: formData.sun.value
        }
    }

    //add location
    var location = null
    if (formData.address.value){

        location = {address: formData.address.value.name}

        if(formData.address.value.name===formData.address.initial.name){
            location.lng = projectFormReducer.data.lng
            location.lat = projectFormReducer.data.lat
        }
        else if(projectFormReducer.workplaceLong){
            location.lng = projectFormReducer.workplaceLong
            location.lat = projectFormReducer.workplaceLat
        }
    }
    finalObj.location = location;

    var contacts = [];
    //add contacts
    formData.contacts.forEach((contact)=>{
        //if contact name got value add him as an object to the array
        if(contact.name.value){
            var newContact = {
                id: contact.id ? contact.id.value : undefined,
                name: contact.name.value,
                title: contact.title.value,
                email: contact.email.value,
                telephone: contact.telephone.value
            }
            contacts.push(newContact);
        }
    })

    finalObj.contacts = contacts;

    var employees = [];
    //add employees
    formData.employees.forEach((employee)=>{
        //if contact name got value add him as an object to the array
        if(employee.value){
            var newEmployee = {
                id: employee.value.id
            }
            employees.push(newEmployee);
        }
    })

    finalObj.employees = employees;


        var activities = [];
    //add activities
    formData.rootActivities.forEach((rootActivty, index) =>{
        //if rootactivity has a name: create the object
        if (rootActivty.name.value){
            var newRootActivity = {
                id: rootActivty.id ? rootActivty.id.value : undefined,
                name: rootActivty.name.value,
                activities: [],
                subActivities: [],
                position: index+1
            }
            rootActivty.seconds.forEach((second, index)=>{
                if(second.name.value){
                    var newSecond = {
                        id: second.id ? second.id.value : undefined,
                        name: second.name.value,
                        position: index+1
                    }

                    var doesSecondHaveValidChilren = false;

                    second.thirds.forEach((third, index)=>{
                        if (third.name.value){
                            doesSecondHaveValidChilren = true;
                            if(!newSecond.activities) newSecond.activities = [];
                            var newThird = {
                                id: third.id ? third.id.value : undefined,
                                name: third.name.value,
                                unit: third.unit.value,
                                amount: third.amount.value,
                                hoursPerUnit: third.hoursPerUnit.value,
                                sum: third.sum.value,
                                position: index+1
                            }
                            newSecond.activities.push(newThird);
                        }

                    });

                    if (!doesSecondHaveValidChilren){
                        newSecond.unit = second.unit.value;
                        newSecond.amount = second.amount.value;
                        newSecond.hoursPerUnit = second.hoursPerUnit.value;
                        newSecond.sum = second.sum.value;
                        newRootActivity.activities.push(newSecond);
                    }
                    else{
                        newRootActivity.subActivities.push(newSecond);
                    }
                }
            });

            activities.push(newRootActivity);
        }

    });


    finalObj.activities = activities;

    return finalObj;
}


// WEBPACK FOOTER //
// ./src/App/Project/CreateProject/actions.js